import React from 'react';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateLesson = ({ formData, onClose, setFormData, handleAddLesson, handleChange }) => {
    const handleQuillChangedescription = (value) => {
        setFormData((prev) => ({
            ...prev,
            description: value || "",
        }));
    };

    const handleQuillChangeresources = (value) => {
        setFormData((prev) => ({
            ...prev,
            resources: value || "",
        }));
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    {/* Header with close button */}
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold text-gray-800">Create New Lesson</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 text-2xl"
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                    </div>

                    <form onSubmit={handleAddLesson} className="space-y-4">
                        {/* Sort Order Id */}
                        <div className="mb-4">
                            <label className="block text-gray-700">Sort Order Id</label>
                            <input
                                type="text"
                                name="sort_order"
                                value={formData.sort_order}
                                onChange={handleChange}
                                className="border w-full p-2"
                                placeholder="Enter Sort Order"
                            />
                        </div>
                        {/* Lesson Title */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Lesson Title*</label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="Enter lesson title"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>

                        {/* Video URL */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Video URL*</label>
                            <input
                                type="text"
                                name="videoUrl"
                                value={formData.videoUrl}
                                onChange={handleChange}
                                placeholder="Enter video URL"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>

                        {/* Description */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                            <ReactQuill
                                value={formData.description || ""}
                                onChange={handleQuillChangedescription}
                                className="border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                                modules={{
                                    toolbar: [
                                        [{ 'header': [1, 2, false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        ['link', 'image'],
                                        ['clean']
                                    ]
                                }}
                                theme="snow"
                            />
                        </div>

                        {/* Resources */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Resources</label>
                            <ReactQuill
                                value={formData.resources || ""}
                                onChange={handleQuillChangeresources}
                                className="border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
                                modules={{
                                    toolbar: [
                                        [{ 'header': [1, 2, false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        ['link', 'image'],
                                        ['clean']
                                    ]
                                }}
                                theme="snow"
                            />
                        </div>

                        {/* Form Actions */}
                        <div className="flex justify-end space-x-3 pt-4">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                Add Lesson
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateLesson;